import { createEvent } from 'effector';
import { IDataTableRow, TRowStoreReducer } from '../../models';
import { isEqual } from 'lodash';

type TPayload = IDataTableRow[];
type TReducer = TRowStoreReducer<TPayload>;

export const initRowsEvent = createEvent<TPayload>();
export const initRowsReducer: TReducer = (state, payload) => {
  if (isEqual(payload, state)) {
    return state;
  }

  return payload;
};
